import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../services/grupo.service';
import { DeclaracionService } from '../../../../services/declaracion.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-decenlinea',
  templateUrl: './decenlinea.component.html',
  styleUrls: ['./decenlinea.component.css'],
  providers: [GrupoService, DeclaracionService]
})
export class DecenlineaComponent implements OnInit {

  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public declaraciones;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _declaracionService: DeclaracionService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    }
    this.getSolicitudes();
  }

  getSolicitudes() {
    //El 1 que se pasa es el tipo pago: 1 = en ceros
    this._declaracionService.getDeclaracionesTypePayment(this.token, '3').subscribe(
      response => {

        if (response.status == 'success') {
          this.status = response.status;
          this.declaraciones = response.declaraciones;
          this.dtTrigger.next()
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        }
      }
    );
  }

  validar(declaracion_id, estatus) {

    $(".aceptarDec").show();

    var observacion = $("#observacion" + declaracion_id).val();

    let objeto = {
      estatus: estatus,
      observacion: observacion
    };
    var message;

    if (estatus == -2) {
      message = 'Se ha cancelado la declaración en cero, se redireccionara al apartado de las declaraciones.'
    } else {
      message = 'Se ha validado la declaración en cero, se redireccionara al apartado de las declaraciones.'
    }

    this._declaracionService.update(this.token, declaracion_id, objeto).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          $(".aceptarDec").hide();
          alert(message);
          window.location.href = "../panel_de_control/declaraciones-en-cero";
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".aceptarDec").hide();
          alert('Tenemos un error con el servidor, intente más tarde');
        }
      }
    );
  }
}
